import React, { useRef, useState } from 'react';
import { Form } from '@unform/web';
import { FiMail, FiUser, FiLock, FiMap, FiArrowRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import {
  FaWhatsapp,
  FaFileMedical,
  FaNotesMedical,
  FaHospital,
  FaSimplybuilt,
  FaBuilding,
  FaIdBadge,
  FaClinicMedical,
} from 'react-icons/fa';
import { ISigla, readSigla, siglas as siglasRef } from './siglas';
import { MdError, MdDateRange, MdChat } from 'react-icons/md';

import * as Yup from 'yup';
import ReCAPTCHA from 'react-google-recaptcha';
import { FormHandles } from '@unform/core';
import Input from '../../../components/Forms/Input';
import Button from '../../../components/Forms/Button';
import Loader from '../../../components/Loader';
import MaskedInput from '../../../components/Forms/MaskedInput';
import { ResponseMessage } from '../../../components/ResponseMessage';
import getValidationErrors from '../../../utils/getValidationErrors';
import { Error } from './styles';
import SelectSimple from '../../../components/Forms/SelectSimple';
import Whatsapp from '../../../components/WhatsAppCompartilhar';

import api from '../../../services/api';
import { authTitle, recaptchaKey, urlWebsite } from '../../../config';
import { countries } from './countries';
import TextareaInput from '../../../components/Forms/TextareaInput';
import { useToast } from '../../../hooks/Toast';
import CheckboxInput from '../../../components/Forms/CheckboxInput';
import getCep from '../../../services/cep';
import { useLanguage } from '../../../hooks/Language';

interface IRecoverFormData {
  [key : string] : any;
}


interface IRead {
  [key: string]: any;
}


interface ICaptcha {
  getValue(): string;
}

const FormContainer = ({ context = {} }) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const { translate} = useLanguage();
  const [errorMessage, setErrorMessage] = useState<Array<string>>([]);
  const [withPassword, setWithPassword] = useState(false);
  const formRef = useRef<FormHandles>(null);
  const recaptchaRef = useRef(null);
  const getCaptchaValue = (elem: ICaptcha): string => {
    return elem.getValue();
  };
const siglas = readSigla();
  const {addToast} = useToast();

  const [countryISO, setCountryISO] = useState('BR');

  const getCepFromApi = async (value: string): Promise<void> => {
    const cepResponse = await getCep(value);

    if (!cepResponse.error) {
      formRef?.current?.setFieldValue('address', cepResponse.logradouro);
      formRef?.current?.setFieldValue('neighborhood', cepResponse.bairro);
      formRef?.current?.setFieldValue('city', cepResponse.localidade);
      formRef?.current?.setFieldValue('state', cepResponse.uf);
    }
  };


  const handleNewLogin = async (data: IRecoverFormData) => {
    setLoading(true);
    try {
      formRef.current?.setErrors({});
      const schema = Yup.object().shape({
        name: Yup.string().required('Nome obrigatório'),
        email: Yup.string()
          .required('Email obrigatório')
          .email('Preencha um email válido'),
          extra_1: Yup.string().required('Informe se você é colaborador da Unimed - obrigatório'),
          position: Yup.string().required('Cargo obrigatório'),
 
 
          
 
        term: Yup.string().required('Informe se você autoriza o compartilhamento de seus dados.'),
      });
   



      await schema.validate(data, { abortEarly: false });


      const captchaValue =
      getCaptchaValue(recaptchaRef?.current || { getValue: () => '' }) ||
      false;

      const newUser = await api
        .post('/signup', {
          ...data
          
        })
        .catch(error => {
          if (error instanceof Yup.ValidationError) {
            console.log(error);
            const errors = getValidationErrors(error);
            formRef.current?.setErrors(errors);
            setLoading(false);
          }

          addToast({
            type: 'error',
            title: error?.response?.data?.message || error?.response?.data?.error || 'Erro ao cadastrar',
          });
          setLoading(false);
          return false;
        });

      if (!newUser) {
        setLoading(false);
        return false;
      }

      setSuccess(true);
      setLoading(false);
     

      return false;
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);

        formRef.current?.setErrors(errors);

        const errorInfo = err.errors.reduce((error, prev) => {
          prev = `${prev}, ${error}`;
          return prev;
        });
        setLoading(false);
        addToast({
          type: 'error',
          title: 'Erro de validação',
          description: errorInfo,
        });
      }
      setLoading(false);
    }
  }

  return (
    <>
      {loading === true && (
        <Loader message="Preparando seu cadastro..." position="fixed" />
      )}

      <aside>
        {success ? (
          <ResponseMessage
            active
            type="clean"
            title=""
            description={
              <p style={{color: '#fff'}}>
                <h2 className="titleH2" style={{color: '#fff'}}> Agradecemos sua inscrição.</h2>
                <br />
          

                
                 <br/>Agora é só registrar o dia do evento na sua agenda. O seu acesso será por meio deste site
 
<br/><br/>
<div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Link to="login">
                  <button className="defaultButtonReverse" type="button">
                    Acessar plataforma
                  </button>
                </Link>
                </div>

                <Whatsapp
                  text={translate(`Olá! Acabei de me inscrever no ${authTitle}. Inscreva-se também!. ${urlWebsite}`)}
                  number=""
                  message={translate('Compartilhar o evento')}
                />
                
                
              </p>
            }
          />
        ) : (<>
           
                  <Form ref={formRef} style={{background: '#00995D', padding: '15px', border:'2px solid #fff', borderRadius: '15px'}} onSubmit={handleNewLogin} initialData={{country: 'BR'}}>
                    <h1 style={{color: '#fff'}}>Seja bem-vindo!</h1>
                    <br/>
                    <p style={{color: '#fff', marginBottom: '20px', textAlign:'left', fontSize:'14px'}}>
                    É muito bom contar com a sua inscrição no <strong>6º Encontro de OPME</strong>. Os dados coletados neste formulário são para registrarmos a sua inscrição e enviarmos informações antes e depois do evento. Os seus dados ficarão armazenados no setor de Comunicação da Unimed Central-RS por 60 dias após o evento.
<br/><br/>
Data: 17/05/2022 (terça-feira)
<br/>Horário: 14h às 17h
 
                    </p>

                    <Input name="name" placeholder="Nome completo" />
                    <Input name="position" placeholder="Cargo" />
                    <Input name="email" placeholder="E-mail" />
                    <SelectSimple 
                      options={[
                        { label: 'Sim', value: 'Sim' },
                        { label: 'Não', value: 'Não' },
                      ]}
                      name="extra_1"
                      formRef={formRef}
                      label={'Você é colaborador do Sistema UNIMED?'}
                    /> 


                    <Input
                      name="company"
                      placeholder="Em qual cooperativa você trabalha?"
                    />
                    
           
   <SelectSimple 
                      options={[
                        { label: 'Acre (AC)', value: 'Acre (AC)' },
                        { label: 'Alagoas (AL)', value: 'Alagoas (AL)' },
                        { label: 'Amapá (AP)', value: 'Amapá (AP)' },
                        { label: 'Amazonas (AM)', value: 'Amazonas (AM)' },
                        { label: 'Bahia (BA)', value: 'Bahia (BA)' },
                        { label: 'Ceará (CE)', value: 'Ceará (CE)' },
                        {
                          label: 'Distrito Federal (DF)',
                          value: 'Distrito Federal (DF)',
                        },
                        { label: 'Espírito Santo (ES)', value: 'Espírito Santo (ES)' },
                        { label: 'Goiás (GO)', value: 'Goiás (GO)' },
                        { label: 'Maranhão (MA)', value: 'Maranhão (MA)' },
                        { label: 'Mato Grosso (MT)', value: 'Mato Grosso (MT)' },
                        {
                          label: 'Mato Grosso do Sul (MS)',
                          value: 'Mato Grosso do Sul (MS)',
                        },
                        { label: 'Minas Gerais (MG)', value: 'Minas Gerais (MG)' },
                        { label: 'Pará (PA)', value: 'Pará (PA)' },
                        { label: 'Paraíba (PB)', value: 'Paraíba (PB)' },
                        { label: 'Paraná (PR)', value: 'Paraná (PR)' },
                        { label: 'Pernambuco (PE)', value: 'Pernambuco (PE)' },
                        { label: 'Piauí (PI)', value: 'Piauí (PI)' },
                        { label: 'Rio de Janeiro (RJ)', value: 'Rio de Janeiro (RJ)' },
                        {
                          label: 'Rio Grande do Norte (RN)',
                          value: 'Rio Grande do Norte (RN)',
                        },
                        {
                          label: 'Rio Grande do Sul (RS)',
                          value: 'Rio Grande do Sul (RS)',
                        },
                        { label: 'Rondônia (RO)', value: 'Rondônia (RO)' },
                        { label: 'Roraima (RR)', value: 'Roraima (RR)' },
                        { label: 'Santa Catarina (SC)', value: 'Santa Catarina (SC)' },
                        { label: 'São Paulo (SP)', value: 'São Paulo (SP)' },
                        { label: 'Sergipe (SE)', value: 'Sergipe (SE)' },
                        { label: 'Tocantins (TO)', value: 'Tocantins (TO)' },
                        { label: 'Não sou Brasileiro', value: 'Não sou Brasileiro' },
                      ]}
                      name="state"
                      formRef={formRef}
                      label={'Qual o estado da sua cooperativa?'}
                    /> 

 
                   



<CheckboxInput
              style={{ display: 'flex'  }}
              name="term"
              unique={true}
              preText={(
                <>
                  {' '}
                  Estou ciente de que estou fornecendo à {authTitle} e seus parceiros meus
                  contatos gerais, os quais são dados pessoais protegidos pela
                  Lei Geral de Proteção de Dados brasileira, para gestão de
                  relacionamento e marketing da empresa, conforme Política de Privacidade disponível neste site.
{' '}
                 
                </>
              )}
              options={[
                {
                  id: `Sim, eu autorizo o compartilhamento dos meus dados`,
                  label: 'Sim, eu autorizo o compartilhamento dos meus dados',
                  value: `Sim, eu autorizo o compartilhamento dos meus dados`,
                },
                {
                  id: `Não autorizo o compartilhamento dos meus dados`,
                  label: 'Não autorizo o compartilhamento dos meus dados',
                  value: `Não autorizo o compartilhamento dos meus dados`,
                },
              ]}
            />

<p
                style={{
                  padding: '10px',
                  background: 'none',
                  margin: '5px auto',
                  color: '#fff',
                  fontSize: '12px',
                  textAlign: 'left',
                }}
              >
                {'Ao me cadastrar, afirmo que li a'}
{' '}
                <strong>
                  <Link
                    style={{ display: 'inline', color: '#fff' }}
                    to="/termos"
                    target="_BLANK"
                  >
                    {'Política de Privacidade'}
{' '}
                  </Link>
{' '}
                </strong>
                {'desta plataforma.'}
              </p>

                    <aside style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <ReCAPTCHA ref={recaptchaRef} sitekey={recaptchaKey} />

                    </aside>  <aside style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <button className="defaultButtonReverse" type="submit">
                      Finalizar inscrição

                  
                    </button>
                    </aside>
                  </Form>
        </>
        )}
      </aside>
    </>
  );
};

export default FormContainer;
